// Holds the live CognitoUser challenge object in plain module scope -
// deliberately NOT passed through React Router's navigate(path, { state })
// mechanism.
//
// navigate's state option goes through history.pushState() under the
// hood, which requires its argument to be structured-cloneable.
// CognitoUser instances (amazon-cognito-identity-js) hold an internal
// reference to a Storage object (their token cache) - Storage objects are
// NOT structured-cloneable, so passing one through router state throws
// "Failed to execute 'pushState' on 'History': Storage object could not
// be cloned" at navigation time, not at some later point where it'd be
// easier to trace back to this.
//
// A plain module-scoped variable has no such restriction - it only needs
// to survive one client-side navigation within the same page load, which
// this SPA already guarantees (no full reload happens between /login and
// /set-new-password). Same reasoning as before still applies for why this
// can't be real persisted state: a hard reload loses it, which
// SetNewPassword.jsx treats as "no challenge to complete" and bounces
// back to /login rather than rendering a broken form.

let pendingChallenge = null;

export function setPendingChallenge(challenge) {
  pendingChallenge = challenge;
}

export function getPendingChallenge() {
  return pendingChallenge;
}

export function clearPendingChallenge() {
  pendingChallenge = null;
}
